import type { SliceCreator } from '../types';

export interface PreferencesSlice {
  /**
   * Mirrors the OS `prefers-reduced-motion` setting, kept in sync by
   * AnimationManager. When true, reveals are skipped, the ambient
   * background holds still and smooth scrolling is disabled.
   */
  prefersReducedMotion: boolean;

  setReducedMotion: (prefers: boolean) => void;
}

export const createPreferencesSlice: SliceCreator<PreferencesSlice> = (set) => ({
  prefersReducedMotion: false,

  setReducedMotion: (prefersReducedMotion) => {
    set((state) =>
      state.prefersReducedMotion === prefersReducedMotion ? state : { prefersReducedMotion },
    );
  },
});
